import { Fragment, useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import notifyContext from "../Context/notifyContext";

import "./App.scss";
import Main from "../Main/Main";
import Login from "../Login/Login";
import {
  getTokenData,
  hasAuthentificated,
  logout,
} from "../../services/Auth__Service";
import AuthContext from "../Context/AuthContext";
import Clients from "../Clients/Clients";
import ForgotPassword from "../ForgotPassword/ForgotPassword";
import Salaries from "../Salaries/Salaries";
import { LOCAL_STORAGE_NAME, PROFIL_USER } from "../../services/config";
import { getItem } from "../../services/LocalStorage";

function App() {
  const notify = (message, type = "success") => {
    if (type === "error") {
      toast.error(`${message}`, {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { border: " 5px solid red" },
      });
    } else if (type === "success") {
      toast.success(`${message}`, {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { border: " 5px solid green" },
      });
    }
  };

  const [isAuthentificated, setIsAuthentificated] = useState(
    hasAuthentificated()
  );

  const redirect = useNavigate();
  const location = useLocation();
  useEffect(() => {
    // window.addEventListener("storage", ()=>{

    // })

    if (
      location.pathname.split("/")[1] !== "login" &&
      location.pathname.split("/")[1] !== "forgotpassword"
    ) {
      if (!isAuthentificated) {
        logout();
        redirect("/login");
      } else {
        if (getItem(LOCAL_STORAGE_NAME) === undefined) {
          setIsAuthentificated(false);
          redirect("/login");
        } else {
          const data = getTokenData();
          const profil = PROFIL_USER.find((elt) => {
            return parseInt(elt.profil) === parseInt(data.profil);
          });

          if (profil === undefined) {
            logout();
            setIsAuthentificated(false);
            redirect("/login");
          } else {
            if (
              !(
                "/" + location.pathname.split("/")[1] ===
                "/" + profil.link.split("/")[1]
              )
            ) {
              logout();
              setIsAuthentificated(false);
              redirect("/login");
            }
          }
        }
      }
    }
  }, [isAuthentificated, location, redirect]);

  return (
    <Fragment>
      <AuthContext.Provider value={{ isAuthentificated, setIsAuthentificated }}>
        <notifyContext.Provider value={notify}>
          <Routes>
            <Route path="/main/*" exact element={<Main />} />
            <Route path="/client/*" exact element={<Clients />} />
            <Route path="/salarie/*" exact element={<Salaries />} />
            <Route path="/login" exact element={<Login />} />
            <Route path="/forgotpassword" exact element={<ForgotPassword />} />
            <Route path="*" element={<Login />} />
          </Routes>
          <ToastContainer />
        </notifyContext.Provider>
      </AuthContext.Provider>
    </Fragment>
  );
}

export default App;
